import axios from 'axios';
import qs from 'qs';
var service = axios.create({
    baseURL: '',
    timeout: 60000,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});
service.interceptors.request.use(function (config) {
    config.data = qs.stringify(config.data);
    return config;
}, function (error) {
    return Promise.error(error);
});
service.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    return Promise.resolve(error.response);
});
export default service;